export default "__VITE_ASSET__4ec29fe3__"